import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { Context } from '../../index';
import {deluser} from '../../services/StudentService';
import { toast } from 'react-toastify';
import { FaWrench } from 'react-icons/fa';
import useIsMobile from "../../utils/useIsMobile";
import {FiSettings} from "react-icons/fi";


function SettingsPageT() {


  const { store } = useContext(Context);
  const navigate = useNavigate();
  const [isDeletePopupVisible, setDeletePopupVisible] = useState(false);

  const isMobile = useIsMobile(); // default breakpoint is 550px


  const showDeletePopup = () => {
    setDeletePopupVisible(true);
  };

  const handleCancelClick = () => {
    setDeletePopupVisible(false);
  };

  const handleDeleteConfirm = async () => {
    try {
      const studentId = store.user.id
      const response = await deluser(studentId);
      // Handle success or show a message
      console.log('Account deleted successfully:', response);
      // Close the popup
      setDeletePopupVisible(false);
      store.setAuth(false)
      // Optionally, navigate to a different page after deletion
      navigate('/');
      toast.success ('Ditt konto är nu raderad');
    } catch (error) {
      console.error('Error deleting account:', error);
      // Handle error or show an error message
    }
  };

  return (
    <div className={'center'} style={{ maxWidth: '500px', margin: '0 auto', marginTop: '100px' }}>
      <h3 className="pt-32 pb-8 center flex"><FiSettings size={27} /></h3>

      <h2 className="center pb-64">Dina konto inställningar</h2>

      <div style={{ margin: '0 auto', maxWidth: '350px' }}>
        <button onClick={() => navigate('/mypass')} className={`${isMobile ? 'buttonM ' : 'button '}`}>
          Byt lösenord
        </button>
        <button onClick={() => navigate('/mydetails')} className={`${isMobile ? 'buttonM' : 'button'}`}>
          Dina uppgifter
        </button>

        <div className="center pt-64">
          {/* Add a delete button that triggers the showDeletePopup function */}
          <button onClick={showDeletePopup} className={`${isMobile ? 'ghostbuttonM' : 'ghostbuttonStart'}`}>
            Radera mitt konto
          </button>
        </div>

        {/* Delete confirmation popup */}
        {isDeletePopupVisible && (
          <div className="popup-overlay">
            <div className="popup" style={{width: 350, height: 400, textAlign: "center"}}>
              <h2>Varning! Du håller på att radera ditt konto!</h2>
                <p className='pt-8'>All din data kommer att raderas permanent</p>
              <div className='mt-32 center' >
            <button onClick={handleDeleteConfirm} className="buttonM">
               Jag samtycker, ta bort mitt konto
              </button>
              <button onClick={handleCancelClick} className="ghostbutton">
                Avbryt
              </button>
              </div>
         
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SettingsPageT;


